<script>
	export let data = {};

	let items = [];
	$: {
		items = [];
		const c = Number(data.colmun);
		for (let i = 1; i <= c; i++) {
			if (data["image" + i]) {
				items.push({
					src: data["image" + i],
					caption: data["caption" + i] || "",
				});
			}
		}
	}
</script>

<div class="UIImage" class:_slim={data.slim === "+" && data.colmun === "1"}>
	{#each items as { src, caption }}
		<figure>
			<img {src} alt={caption} />
			<figcaption>{@html caption.split("\n").join("<br>")}</figcaption>
		</figure>
	{/each}
</div>

<style global>
	.UIImage {
		padding: 1em 0;
		max-width: 1024px;
		overflow: hidden;
		margin: 0 auto;
	}
	.UIImage._slim {
		max-width: 720px;
	}

	:global(.pc) .UIImage {
		display: flex;
		width: 100%;
	}

	.UIImage > figure {
		width: 100%;
	}

	:global(.pc) .UIImage > figure:not(:first-child) {
		margin-left: 1em;
	}

	.UIImage img {
		width: 100%;
	}
	.UIImage figcaption {
		font-size: 0.8em;
		color: #888;
		padding: 0.25em 0 0;
	}
</style>
